import React, {useEffect, useState} from "react";
import {Button, Layout} from "antd";
import {Link, useParams} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {basePath, PATH} from "../../config";
import { redirectTo } from "../../config/CoreMethods";
import {useSelector} from "react-redux";
import {ROUTES as ROUTES_CONFIG} from "../../config/constants";
import axiosData from "../../helpers/axiosData";

const { Content } = Layout

const NewPass = () => {

    const [UserData, setUserData] = useState({})
    let { hash } = useParams();

    
    const sendNewPassword = () => {

        if (UserData.password.length > 0  &&  UserData.password==UserData.repeat_password &&  typeof UserData.hash == 'string' && /^([a-z0-9]{44,46})$/.test(UserData.hash) ) {
            
            axiosData.post("/api/_web3/user/new-password/", {hash: UserData.hash, password: UserData.password}).then((res) => {
                // console.log('res.data.data', res.data)
                if (res.data.success) {
                    
                    toast.success('Your password successfully was reset. Please, Log In')
                    
                } else {
                    toast.error('OOPS! Something went wrong.')
                }
            })
        } else {
            toast.error('OOPS! Type Valid Data')
        }

    }

    const setFormData = (data, key, type='text') => {
        // console.log('setFormData - data, key, type', data, key, type, ' ----- UserData', UserData)

        let newUserData = UserData;

        if (type == 'text' || type == 'check') {

            if(type == 'check') {

                newUserData[key] =  data ? 1 : 0;
            } else {
                newUserData[key] = data;
            }

            setUserData(newUserData);
        }
        console.log('FormData ', UserData)
    }

    let BackLogin = useSelector(state => state.metahut.BackLogin)

    if (BackLogin) {
        redirectTo(basePath)
    }

    const SetPass = () => {
        if (UserData.newPass != UserData.rePass) {
            toast.error("Error Occured!");
        }
    }

    useEffect(()=>{
        setFormData(hash, 'hash')
    },[hash])

    return (
        <div className="min-h-calc-head h-full flex items-center justify-center" style={{paddingTop: "92px", background: `url(${PATH + 'bg-auth.png'}) center center / cover`}}>
            <div className="container mx-auto">
                <Layout className="bg-transparent h-full">
                    <Content className="pt-4 pb-4 pl-14 pr-14 xs-p-2">
                        <div className="flex flex-col items-center gap-y-5">
                            <div className="login-note">
                                Please make sure you are visiting
                                <div>
                                    <i className="icon-lock-closed text-green-400 mr-1"></i>
                                    <span className="text-green-400"> https://</span>app.metafluence.com
                                </div>
                            </div>
                            <ToastContainer />
                            <div className="flex justify-center">
                                <div className="login-form form-box">
                                    <h1 className="text-center text-white font-normal text-xl mb-6">Reset Password</h1>
                                    <label htmlFor="acc_username" className="text-white text-base font-light mb-2 block">New Password</label>
                                    <div className="flex items-center gap-x-6 mb-4 xs-w-100">
                                        <input
                                            className="bg-indigo-700 border-0 rounded-md text-white login-input w-100"
                                            type="password"
                                            name="newPass"
                                            onChange={(e) => setFormData(e.target.value, 'password')}
                                        />
                                    </div>
                                    <label htmlFor="acc_username" className="text-white text-base font-light mb-2 block">Repeat New Password</label>
                                    <input
                                        className="bg-indigo-700 border-0 rounded-md text-white login-input w-100"
                                        type="password"
                                        name="rePass"
                                        onChange={(e) => setFormData(e.target.value, 'repeat_password')}
                                    />
                                    <div className="flex justify-center mt-7">
                                        <Button type="submit" onClick={sendNewPassword} className="border-0 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-medium text-base login-btn flex items-center justify-center gap-x-3">
                                            Set New Password
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </div>
        </div>
    )
}

export default NewPass;